"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MagicConnector = void 0;
const schemas_1 = require("@dcl/schemas");
const configuration_1 = require("../configuration");
const AbstractConnector_1 = require("./AbstractConnector");
class MagicConnector extends AbstractConnector_1.AbstractConnector {
    constructor(desiredChainId) {
        super({ supportedChainIds: configuration_1.getConfiguration()[schemas_1.ProviderType.MAGIC].chains });
        this.activate = async () => {
            var _a;
            this.magic = await this.buildMagicInstance(this.chainId);
            const isLoggedIn = await this.magic.user.isLoggedIn();
            if (!isLoggedIn) {
                throw new Error('Magic: user isn\'t logged in');
            }
            const provider = await this.getProvider();
            const accounts = (await provider.request({ method: 'eth_accounts' }));
            this.account = (_a = accounts[0]) !== null && _a !== void 0 ? _a : null;
            return {
                provider,
                chainId: this.chainId,
                account: this.account
            };
        };
        this.getProvider = async () => {
            if (!this.magic) {
                throw new Error('Magic: instance was not initialized');
            }
            const provider = await this.magic.wallet.getProvider();
            return Object.assign(Object.assign({}, provider), { request: new Proxy(provider.request, {
                    apply: async (target, _thisArg, argumentsList) => {
                        var _a, _b, _c;
                        // Magic doesn't support the "wallet_switchEthereumChain" method, we need to re-instantiate the Magic instance
                        if (((_a = argumentsList[0]) === null || _a === void 0 ? void 0 : _a.method) === 'wallet_switchEthereumChain') {
                            try {
                                const chainId = parseInt((_c = (_b = argumentsList[0]) === null || _b === void 0 ? void 0 : _b.params[0]) === null || _c === void 0 ? void 0 : _c.chainId, 16);
                                if (this.supportedChainIds && !this.supportedChainIds.includes(chainId)) {
                                    return {
                                        code: 2020202,
                                        message: 'Unsupported Magic ChainId'
                                    };
                                }
                                this.magic = await this.buildMagicInstance(chainId);
                                this.emitUpdate({ chainId });
                                return null;
                            }
                            catch (error) {
                                return {
                                    code: 2020201,
                                    message: 'Error changing the Magic ChainId'
                                };
                            }
                        }
                        return target.bind(provider)(...argumentsList);
                    }
                }) });
        };
        this.getChainId = async () => {
            if (!this.magic) {
                throw new Error('Magic: instance was not initialized');
            }
            return this.chainId;
        };
        this.getAccount = async () => {
            if (!this.magic) {
                throw new Error('Magic: instance was not initialized');
            }
            return this.account;
        };
        this.deactivate = () => {
            if (!this.magic) {
                throw new Error('Magic: instance was not initialized');
            }
            this.magic.user.logout();
            this.emitDeactivate();
        };
        this.buildMagicInstance = async (chainId) => {
            const { Magic } = await Promise.resolve().then(() => __importStar(require('magic-sdk')));
            const { OAuthExtension } = await Promise.resolve().then(() => __importStar(require('@magic-ext/oauth')));
            const magicConfiguration = configuration_1.getConfiguration()[schemas_1.ProviderType.MAGIC];
            return new Magic(magicConfiguration.apiKey, {
                extensions: [new OAuthExtension()],
                network: {
                    rpcUrl: magicConfiguration.urls[chainId],
                    chainId: chainId
                }
            });
        };
        this.chainId = desiredChainId;
        this.account = null;
    }
}
exports.MagicConnector = MagicConnector;
//# sourceMappingURL=MagicConnector.js.map